import { useFrame } from "@react-three/fiber"
import { useControls } from "leva"
import { useEffect, useRef } from "react"
import { movePropertiesRange, scaleRange } from "../../../utils/moveObjects"
import { useActsStore } from "../../../store/useActsStore"
import { useIsMobile } from "../../../utils/useIsMobile"


export default function Sun(props) {
  const isMobile = useIsMobile()
  const ref = useRef()
  const sun = useRef()
  useEffect(() => {
    if (!ref.current) return

    ref.current.onBeforeCompile = (shader) => {
      shader.uniforms.uTime = { value: 0 }
      shader.uniforms.uStrength = { value: 20 } // nb de "tours"
      shader.uniforms.uRadius = { value: 15 }   // rayon d'influence

      shader.vertexShader = shader.vertexShader
        .replace(
          '#include <common>',
          `
        #include <common>
        uniform float uTime;
        uniform float uStrength;
        uniform float uRadius;
        `
        )
        .replace(
          '#include <begin_vertex>',
          `
        #include <begin_vertex>

        vec3 p = transformed;

        // ***** SPIRALE DANS LE PLAN XY = autour de l'axe Z (face caméra) *****
        float r = length(p.xy);
        float rn = clamp(r / uRadius, 0.0, 1.0);

        // plus on va vers le centre, plus ça tourne
        float spiral = uStrength * (1.0 - rn) * (1.0 - rn);

        float angle = atan(p.y, p.x) + spiral;

        p.x = cos(angle) * r;
        p.y = sin(angle) * r;

        transformed = p;
        `
        )

      ref.current.userData.shader = shader
    }

    ref.current.needsUpdate = true
  }, [])


  useFrame((_, delta) => {
    const stateActe = useActsStore.getState()
    const id = stateActe.getCurrentActId()

    const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0

    if (id === 1) {
      movePropertiesRange(id, ref, "thickness", 0.3, -5, holdProgress, 0.3, 0.8, 10, delta)
      movePropertiesRange(id, ref, "ior", 0.95, -0.7, holdProgress, 0.4, 0.8, 10, delta)
      movePropertiesRange(id, ref, "dispersion", 1, 10, holdProgress, 0.4, 0.8, 10, delta)
      movePropertiesRange(id, ref, "emissiveIntensity", 0, 1, holdProgress, 0.65, 0.8, 10, delta)
    }

    if(id===1 && isMobile) {
      scaleRange(sun, 2, -1.8, holdProgress, 0.6, 0.8, 1, delta)
      scaleRange(sun, 0.2, 1.8, holdProgress, 0.8, 1, 1, delta)
    }

  })

  return (
    <mesh {...props} ref={sun}>
      <sphereGeometry args={[2, 120, 60]} />
      <meshPhysicalMaterial
        ref={ref}
        emissive={'#c7e9ff'}
        emissiveIntensity={0}
        roughness={0.2}
        metalness={0}
        transmission={0.95}
        thickness={0.3}
        ior={0.95}
        clearcoat={1}
        clearcoatRoughness={1}
        dispersion={1}
      />
    </mesh>
  )
}